import inputs from './inputs';

const selects = {
  ...inputs,
};

export default selects;
